import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-[#F7F9FB]" data-testid="terms-page">
      <div className="sticky top-0 z-10 bg-white border-b border-[#E5E7EB]">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center gap-3">
          <Link to="/" data-testid="terms-back" className="text-[#6B7280] hover:text-[#1F3A5F]">
            <ArrowLeft size={20} />
          </Link>
          <h1 className="text-lg font-bold text-[#1F3A5F]">Terms of Service</h1>
        </div>
      </div>

      <article className="max-w-3xl mx-auto px-4 py-8 prose prose-sm text-[#2C2C2C]">
        <p className="text-xs text-[#6B7280]">Last updated: February 2026</p>

        <h2 className="text-xl font-bold text-[#1F3A5F] mt-6">Acceptance of terms</h2>
        <p>
          By creating an account or using SayItBetter (the "Service"), you agree to these Terms of Service
          ("Terms"). If you do not agree, do not use the Service.
        </p>

        <h2 className="text-xl font-bold text-[#1F3A5F] mt-6">Who can use SayItBetter</h2>
        <p>
          You must be at least 13 years old to use SayItBetter. By using the Service you represent that
          you meet this age requirement and that you are legally able to form a binding contract.
        </p>

        <h2 className="text-xl font-bold text-[#1F3A5F] mt-6">Your account</h2>
        <p>
          You are responsible for keeping your login credentials secure and for all activity on your account.
          Notify us immediately at <a href="mailto:hello@sayitbetter.me" className="text-[#2F5BFF] font-medium">hello@sayitbetter.me</a>
          if you suspect unauthorized access.
        </p>

        <h2 className="text-xl font-bold text-[#1F3A5F] mt-6">AI-generated content — important disclaimer</h2>
        <p>
          SayItBetter uses artificial intelligence to analyze messages and suggest rewrites. Suggestions are
          generated by a language model and <strong>are not a substitute for professional counseling,
          therapy, legal, or crisis support</strong>. The Service does not replace human judgment. You are
          solely responsible for any message you ultimately send.
        </p>
        <p>
          If you are in crisis or experiencing thoughts of self-harm, please contact a local crisis line
          (such as 988 in the U.S.) or emergency services immediately.
        </p>

        <h2 className="text-xl font-bold text-[#1F3A5F] mt-6">Acceptable use</h2>
        <p>You agree not to use SayItBetter to:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Harass, threaten, stalk, or harm another person.</li>
          <li>Generate content that is unlawful, hateful, sexually explicit involving minors, or infringes
            the rights of others.</li>
          <li>Attempt to reverse-engineer, scrape, or abuse the Service.</li>
          <li>Submit confidential or sensitive information that you are not authorized to share.</li>
        </ul>

        <h2 className="text-xl font-bold text-[#1F3A5F] mt-6">Subscriptions and payments</h2>
        <p>
          Free tier features are limited. Paid subscriptions, if purchased, renew automatically unless
          cancelled. Prices and features are subject to change; we'll notify you of material changes.
        </p>

        <h2 className="text-xl font-bold text-[#1F3A5F] mt-6">Intellectual property</h2>
        <p>
          SayItBetter and its brand, name, and technology are owned by us. You retain ownership of text you
          submit and of rewrites you choose to send. You grant us a limited license to process that text to
          provide the Service.
        </p>

        <h2 className="text-xl font-bold text-[#1F3A5F] mt-6">Termination</h2>
        <p>
          You can stop using SayItBetter at any time and delete your account from Settings or at
          {" "}<Link to="/delete-account" className="text-[#2F5BFF] font-medium">sayitbetter.me/delete-account</Link>.
          We may suspend or terminate accounts that violate these Terms.
        </p>

        <h2 className="text-xl font-bold text-[#1F3A5F] mt-6">Disclaimers</h2>
        <p>
          THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR
          IMPLIED. WE DO NOT GUARANTEE THAT THE SERVICE WILL BE UNINTERRUPTED, SECURE, OR ERROR-FREE.
        </p>

        <h2 className="text-xl font-bold text-[#1F3A5F] mt-6">Limitation of liability</h2>
        <p>
          TO THE MAXIMUM EXTENT PERMITTED BY LAW, SAYITBETTER AND ITS AFFILIATES WILL NOT BE LIABLE FOR ANY
          INDIRECT, INCIDENTAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM YOUR USE OF THE SERVICE.
        </p>

        <h2 className="text-xl font-bold text-[#1F3A5F] mt-6">Changes to these terms</h2>
        <p>
          We may update these Terms from time to time. Continued use of SayItBetter after changes become
          effective constitutes acceptance of the updated Terms.
        </p>

        <h2 className="text-xl font-bold text-[#1F3A5F] mt-6">Contact</h2>
        <p>
          Questions about these Terms? Email
          {" "}<a href="mailto:hello@sayitbetter.me" className="text-[#2F5BFF] font-medium">hello@sayitbetter.me</a>.
        </p>
      </article>
    </div>
  );
}
